import MainBanner2 from './MainBanner2';

export default MainBanner2;
